import { Rate, ServiceRatePricing } from '@mews-commander/data-access';

export const isRateRestricted = (
    rate: Rate,
    pricingByRateId: Record<string, ServiceRatePricing | undefined>
): boolean => {
    let isRestricted = false;

    if (rate.baseRateId && pricingByRateId[rate.baseRateId]?.isRestricted) {
        isRestricted = true;
    }

    return isRestricted || !!pricingByRateId[rate.id]?.isRestricted;
};
